Keys = require 'data/keys'
Label = require 'models/label'
_ = require 'underscore'

module.exports = class LabelKeyHelper

  @keyboardIndex: \
    [_.last(Label.colors)].concat(_.initial(Label.colors))

  @keyNumberForColor: (color) ->
    ix = @keyboardIndex.indexOf(color)
    return if ix >= 0 then "#{ix}" else null

  @colorForKey: (key) ->
    labelIndex = (key - Keys._0)
    @keyboardIndex[labelIndex]

  @setLabelFromKey: (key, card, fxNoUniqueLabel) ->
    color = @colorForKey(key)
    boardMatches = card.getBoard().labelsForColors()[color]
    if boardMatches?.length == 1
      card.toggleLabelColor(color)
    else
      fxNoUniqueLabel?(color)
    return



// WEBPACK FOOTER //
// ./app/scripts/views/label/label-key-helper.coffee